import { QueryClientProvider } from '@tanstack/react-query';
// import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { createRootRoute, Outlet } from '@tanstack/react-router';
// import { TanStackRouterDevtools } from '@tanstack/react-router-devtools';
import * as React from 'react';
import { Toaster } from 'sonner';

import { EnvBanner } from '@/components/env-banner';
import { queryClient } from '@/lib/query-client';
import { useAuthStore } from '@/stores';

export const Route = createRootRoute({
  component: RootComponent,
});

function RootComponent() {
  const initialize = useAuthStore((state) => state.initialize);

  React.useEffect(() => {
    initialize();
  }, [initialize]);

  return (
    <QueryClientProvider client={queryClient}>
      <EnvBanner />
      <div className="bg-background font-sans antialiased">
        <Outlet />
      </div>
      <Toaster position="top-center" richColors />
      {/* <ReactQueryDevtools initialIsOpen={false} /> */}
      {/* <TanStackRouterDevtools /> */}
    </QueryClientProvider>
  );
}
